import axios from 'axios';

export function getApiErrorMessage(error: unknown, fallback = 'Une erreur est survenue.'): string {
    if (axios.isAxiosError(error) && error.response?.data) {
        const data = error.response.data as {
            message?: string;
            errors?: Record<string, string[]>;
        };

        if (data.errors) {
            return Object.values(data.errors).flat().join(' ');
        }

        if (data.message) {
            return data.message;
        }
    }

    return error instanceof Error ? error.message : fallback;
}

export function normalizeResourceList<T>(payload: unknown): T[] {
    if (Array.isArray(payload)) {
        return payload as T[];
    }

    const data = payload as { data?: T[] };
    return data.data ?? [];
}
